import { useEffect } from 'react';

import { DwellTimeHelper } from '@atlassiansox/analytics-web-client';

import { onAdvancedSearchDwelled } from '../../common/utils/events/advanced-search-dwelled';
import { useAnalytics } from '../analytics';
import { useApplicationMode, useSearchSessionId } from '../store/bootstrap';
import { useSearchQuery } from '../store/search';

const useDwellTime = (): void => {
	const { fireAnalyticsEvent } = useAnalytics();
	const [searchSessionId] = useSearchSessionId();
	const [searchQuery] = useSearchQuery();
	const applicationMode = useApplicationMode();

	useEffect(() => {
		const dwellTimer = new DwellTimeHelper(
			(dwellData: any) => {
				fireAnalyticsEvent(
					onAdvancedSearchDwelled({
						dwellData,
						searchQuery,
						searchSessionId,
						applicationMode,
					}),
				);
			},
			// These actually get overridden in onAdvancedSearchDwelled, but the DwellTimeHelper code path requires them to be set anyway, so we do.
			{
				source: 'source',
				actionSubject: 'actionSubject',
			},
			searchSessionId,
		);
		dwellTimer.start();

		return () => {
			dwellTimer.stop();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};

export default useDwellTime;
